import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./styleNewOrder.css";
import HeroImg from "../images/hero_img.png";

export const HeroNewOrder = () => {
    const [govNumber, setGovNumber] = useState("");
    const [techPassportSeria, setSeria] = useState("");
    const [techPassportNumber, setNumber] = useState("");
    const navigate = useNavigate();

    const serialRef = useRef(null);
    const numberRef = useRef(null);

    const handleSubmit = () => {
        if (!govNumber || !techPassportSeria || !techPassportNumber) {
            alert("Пожалуйста, заполните все поля");
            return;
        }

        navigate("/vehicle-info", {
            state: {
                govNumber,
                techPassportSeria,
                techPassportNumber,
            },
        });
    };

    return (
        <div className="hero3">
            <div className="hero-content3">
                <div className="hero-texts3">
                    <h1 className="hero-title3">
                        Новая заявка <br />
                        <span className="highlight3">КАСКО онлайн</span>
                    </h1>
                    <p className="hero-subtitle3">
                        Укажите данные автомобиля, чтобы рассчитать стоимость страховки
                    </p>

                    <div className="hero-form3">
                        <div className="form-row3">
                            <div className="input-wrapper3">
                                <label>Гос номер <span>*</span></label>
                                <input
                                    className="input-field3"
                                    type="text"
                                    placeholder="01 A 123 AA"
                                    value={govNumber}
                                    onChange={(e) => {
                                        let value = e.target.value.toUpperCase().replace(/[^A-Z0-9\s]/g, "");
                                        setGovNumber(value);
                                        if (value.length >= 8 && serialRef.current) {
                                            serialRef.current.focus();
                                        }
                                    }}
                                />
                            </div>

                            <div className="input-wrapper3">
                                <label>Серия <span>*</span></label>
                                <input
                                    ref={serialRef}
                                    className="input-field3"
                                    type="text"
                                    placeholder="AAA"
                                    value={techPassportSeria}
                                    onChange={(e) => {
                                        const value = e.target.value.toUpperCase().replace(/[^A-Z]/g, "");
                                        setSeria(value);
                                        if (value.length >= 3 && numberRef.current) {
                                            numberRef.current.focus();
                                        }
                                    }}
                                />
                            </div>

                            <div className="input-wrapper3">
                                <label>Номер <span>*</span></label>
                                <input
                                    ref={numberRef}
                                    className="input-field3"
                                    type="text"
                                    placeholder="1234567"
                                    value={techPassportNumber}
                                    onChange={(e) => setNumber(e.target.value.replace(/[^0-9]/g, ""))}
                                />
                            </div>
                        </div>

                        <button className="hero-button3" onClick={handleSubmit}>
                            Рассчитать
                        </button>
                    </div>
                </div>

                <img className="hero-image3" src={HeroImg} alt="car" />
            </div>
        </div>
    );
};
